import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import * as _ from 'lodash';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import BusinessEntity from 'src/app/services/businessEntity.model';
import BusinessTypeModel from 'src/app/services/businessType.model';
import CustomerDeviceModel from 'src/app/services/customerDevice.model';
import { BusinessTypeService } from 'src/app/services/businessType.service';
import { BusinessEntityService } from 'src/app/services/businessEntity.service';
import { CustomerDeviceService } from 'src/app/services/customerDevice.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BatchLoader } from 'src/app/Utils/batch-loader.util';

@Component({
  selector: 'app-assign-device',
  templateUrl: './assign-device.component.html',
  styleUrls: ['./assign-device.component.scss']
})
export class AssignDeviceComponent implements OnInit, OnDestroy{
  public businessEntities: Array<BusinessEntity>;
  public businessEntity: BusinessEntity;
  public businessTypes: Array<BusinessTypeModel>;
  public customerDevices: Array<CustomerDeviceModel>;
  public customerDevice: CustomerDeviceModel;
  public pgLoad = false;
  // sorting pagination
  public key: string = 'name';
  public reverse: boolean = false;
  public loginPersonType: string;
  public loginUserBusinessName: string;
  public providerBusinessIds = new Array();
  public deviceDetails = new Array();
  public displayDeviceDetails: Array<any> = [];
  public batchLoader?: BatchLoader<any>;
  public listLoader: boolean = false;
  public noList: boolean = false;
  public responseLoader: boolean;
  public businessIds = new Array();
  public isSearchclick: boolean;

  public sort(key: string) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  // pagination sorting
  public currentPageNumber: number = 1;
  public noOfItemsPerPage: number = 20;

  /* End pagination, sorting, filter*/

  constructor(public businessTypeService: BusinessTypeService, public businessEntityService: BusinessEntityService, public customerDeviceService: CustomerDeviceService, public toastr: ToastrService,
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService, private router: Router
  ) {
    this.customerDevice = new CustomerDeviceModel();
    this.customerDevice.selectedCMorFP = '1';
    this.initializeBatchLoader();
  }

  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => this.deviceDetails,
      (updatedList) => {
        this.displayDeviceDetails = updatedList;
        this.noList = updatedList.length === 0;
      },
      undefined,
      (loading) => this.listLoader = loading
    );
  }

  private scrollTimeout: any;

  @HostListener('window:scroll', [])
  public onWindowScroll(): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 &&
        !this.batchLoader?.isLoading()) {
        this.batchLoader?.loadNextBatch();
      }
    }, 50);
  }

  public navigateToAssignDeviceToFarm(list: any): void {
    const providerId = list && list.providerId;
    const deviceId = list && list.device && list.device.id;
    const deviceNumber = list && list.device && list.device.number;
    const isCM = this.customerDevice.selectedCMorFP === '1';
    const businessType = list && list.businessType;
    this.router.navigate(['/home/assigndevicetofarm', providerId, deviceId, deviceNumber, isCM, businessType]);
  }

  public async ngOnInit() {
    this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
    // loginperson type details
    this.loginPersonType = localStorage.getItem('loginPersonType');
    // login person Business name
    this.loginUserBusinessName = localStorage.getItem('loginBusinessName');
    try {
      if (this.loginPersonType == 'Business Admin') {
        this.businessEntities = await this.businessEntityService.getAllfarmerByProviderID(localStorage.businessID);
        this.pgLoad = true;
        for (let i = 0; i < this.businessEntities.length; i++) {
          this.providerBusinessIds.push(this.businessEntities[i].id);
        }
      } else {
        this.businessTypes = await this.businessTypeService.getAllBusinessTypes();
        let result = this.businessTypes.filter(obj => {
            return obj.id === '618a17b80f339c001e991b03' || obj.id === '618a17db0f339c001e991b04';
        });
        let providerIds: any[] = [];
        result.forEach(function(object) {
          providerIds.push(object.id);
        });
        let businessEntities = await this.businessEntityService.getProviderBusiness(providerIds);
        this.pgLoad = true;
        for (let i = 0; i < businessEntities.length; i++) {
          this.providerBusinessIds.push(businessEntities[i].id);
        }
        let businesses = await this.businessEntityService.getAllBusiness();
        this.businessEntities = businesses.filter(obj => {
            return obj.businessType[0] && obj.businessType[0].businessTypeID != '618a18ac0f339c001e991b08';
        });
        this.pgLoad = true;
        for (let i = 0; i < this.businessEntities.length; i++) {
          this.businessIds.push(this.businessEntities[i].id);
        }
      }
      this.deviceDetails = new Array();
      this.responseLoader = true;
      this.isSearchclick = false;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  /* End get all farmsite by login persontype is admin */

//To cancel ongoing requests and unsubscribe from subscriptions.
public ngOnDestroy(): void {
  this.businessEntityService.cancelOnGoingHttpRequests();
  this.businessTypeService.cancelOnGoingHttpRequests();
}
  // Device with Provider list when admin loggedin
  public async getDevicesByselectedType() {
    try {
      if (this.customerDevice.selectedCMorFP == '' || this.customerDevice.selectedCMorFP == undefined || this.customerDevice.selectedCMorFP == null) {
        this.toastr.error('Please select CWM or Farm Provider');
        return false;
      }
      this.responseLoader = false;
      if (this.loginPersonType != 'Business Admin' && parseInt(this.customerDevice.selectedCMorFP) == 0) { // admin
        this.customerDevice.businessIds = this.providerBusinessIds;
      }
      if (this.loginPersonType != 'Business Admin' && parseInt(this.customerDevice.selectedCMorFP) == 1) { // admin
        this.customerDevice.businessIds = this.businessIds;
      }
      if (this.loginPersonType == 'Business Admin') { // provider login
        this.customerDevice.businessIds = [localStorage.businessID];
      }
      this.customerDevice.isCM = this.customerDevice.selectedCMorFP ? parseInt(this.customerDevice.selectedCMorFP) : 0;
      this.isSearchclick = false;
      this.customerDevices = await this.customerDeviceService.getDevicesBuSelectedType(this.customerDevice);
      this.pgLoad = true;
      if (this.customerDevices !== undefined) {
        this.responseLoader = true;
        // this.ProvidersList = this.customerDevices;
        this.isSearchclick = true;
        if (this.loginPersonType == 'Business Admin') {
          this.deviceDetails = new Array();
          if (this.customerDevices && this.customerDevices.length > 0) {
            for (let i = 0; i < this.customerDevices.length; i++) { // loop all objects
              // prepeare device details
              if (this.customerDevices[i] && this.customerDevices[i].DeviceDetails && this.customerDevices[i].DeviceDetails.length > 0) { // check business name is tehre and device list is there
                for (let j = 0; j < this.customerDevices[i].DeviceDetails.length; j++) {
                  if (this.customerDevice.selectedCMorFP === '1' && this.customerDevices[i] && this.customerDevices[i].DeviceDetails[j] && this.customerDevices[i].DeviceDetails[j].pond_id == null && this.customerDevices[i].DeviceDetails[j].isContinuousMonitoring === true) {
                    this.customerDevices[i].DeviceDetails[j].businessName = this.customerDevices[i].businessName;
                    this.customerDevices[i].DeviceDetails[j].providerId = this.customerDevices[i].id;
                    this.customerDevices[i].DeviceDetails[j].businessType = this.customerDevices[i].businessType[0].name;
                    this.deviceDetails.push(this.customerDevices[i].DeviceDetails[j]);
                  } else if (this.customerDevice.selectedCMorFP === '0' && this.customerDevices[i].DeviceDetails[j].isContinuousMonitoring === false) {
                    this.customerDevices[i].DeviceDetails[j].businessName = this.customerDevices[i].businessName;
                    this.customerDevices[i].DeviceDetails[j].providerId = this.customerDevices[i].id;
                    this.customerDevices[i].DeviceDetails[j].businessType = this.customerDevices[i].businessType[0].name;
                    this.deviceDetails.push(this.customerDevices[i].DeviceDetails[j]);
                  }
                }
              }
              // prepare farmsitedetails
              if (this.customerDevices[i] && this.customerDevices[i].FarmSiteDetails && this.customerDevices[i].FarmSiteDetails.length > 0) { // check business name is tehre and device list is there
                for (let k = 0; k < this.customerDevices[i].FarmSiteDetails.length; k++) {
                  const eachfarmsitedDetails = this.customerDevices[i].FarmSiteDetails[k];
                  const allfarmsiteCustomerDevices = this.customerDevices[i].FarmSiteDetails[k].CustomerDevices;
                  for (let index = 0; index < this.customerDevices[i].FarmSiteDetails[k].CustomerDevices.length; index++) {
                    const eachcustomerDevice = this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index];
                    if (this.customerDevice.selectedCMorFP === '1' && this.customerDevices[i] && this.customerDevices[i].FarmSiteDetails[k] && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index] && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].pond_id == null && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].isContinuousMonitoring) {
                      const cudtomerdeiceid = eachcustomerDevice.id; // provider iyethe device details lo vachina id and farmsitedetails lo customer devies lo vachina id same vunte push cheyakudadhu
                      const providerDevicearr = _.filter(this.deviceDetails, function(o) {
                        return o.id === cudtomerdeiceid;
                      });
                      if (providerDevicearr.length === 0) {
                        let business = await this.getBusinessDetailsById(this.customerDevices[i].FarmSiteDetails[k].businessID);
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].providerId = business && business.id;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessName = business && business.businessName;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessType = business && business.businessType[0].name;
                        this.deviceDetails.push(this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index]);
                      }
                    } else if (this.customerDevice.selectedCMorFP === '0' && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].isContinuousMonitoring == false) {
                      const cudtomerdeiceid = eachcustomerDevice.id; // provider iyethe device details lo vachina id and farmsitedetails lo customer devies lo vachina id same vunte push cheyakudadhu
                      const providerDevicearr = _.filter(this.deviceDetails, function(o) {
                        return o.id === cudtomerdeiceid;
                      });
                      if (providerDevicearr.length === 0) {
                        let business = await this.getBusinessDetailsById(this.customerDevices[i].FarmSiteDetails[k].businessID);
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].providerId = business && business.id;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessName = business && business.businessName;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessType = business && business.businessType[0].name;
                        this.deviceDetails.push(this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index]);
                      }
                    }
                  }
                }
              }
              // end prepare farmsitedetails
            }
          }
          // remove duplicates
          this.deviceDetails = _.uniqBy(this.deviceDetails, 'id');
          this.batchLoader?.reset();
          await this.batchLoader?.loadNextBatch(true);
        } else {
          this.deviceDetails = new Array();
          if (this.customerDevices && this.customerDevices.length > 0) {
            for (let i = 0; i < this.customerDevices.length; i++) { // loop all objects
              // prepeare device details
              if (this.customerDevices[i] && this.customerDevices[i].DeviceDetails && this.customerDevices[i].DeviceDetails.length > 0) { // check business name is tehre and device list is there
                for (let j = 0; j < this.customerDevices[i].DeviceDetails.length; j++) {
                  if (this.customerDevice.selectedCMorFP == '1' && this.customerDevices[i] && this.customerDevices[i].DeviceDetails[j] && this.customerDevices[i].DeviceDetails[j].pond_id == null && this.customerDevices[i].DeviceDetails[j].isContinuousMonitoring == true) {
                    this.customerDevices[i].DeviceDetails[j].businessName = this.customerDevices[i].businessName;
                    this.customerDevices[i].DeviceDetails[j].providerId = this.customerDevices[i].id;
                    this.customerDevices[i].DeviceDetails[j].businessType = this.customerDevices[i].businessType[0].name;
                    this.deviceDetails.push(this.customerDevices[i].DeviceDetails[j]);
                  } else if (this.customerDevice.selectedCMorFP == '0' && this.customerDevices[i].DeviceDetails[j].isContinuousMonitoring == false) {
                    this.customerDevices[i].DeviceDetails[j].businessName = this.customerDevices[i].businessName;
                    this.customerDevices[i].DeviceDetails[j].providerId = this.customerDevices[i].id;
                    this.customerDevices[i].DeviceDetails[j].businessType = this.customerDevices[i].businessType[0].name;
                    this.deviceDetails.push(this.customerDevices[i].DeviceDetails[j]);
                  }
                }
              }
              // prepare farmsitedetails
              if (this.customerDevices[i] && this.customerDevices[i].FarmSiteDetails && this.customerDevices[i].FarmSiteDetails.length > 0) { // check business name is tehre and device list is there
                for (let k = 0; k < this.customerDevices[i].FarmSiteDetails.length; k++) {
                  const eachfarmsitedDetails = this.customerDevices[i].FarmSiteDetails[k];
                  const allfarmsiteCustomerDevices = this.customerDevices[i].FarmSiteDetails[k].CustomerDevices;
                  for (let index = 0; index < this.customerDevices[i].FarmSiteDetails[k].CustomerDevices.length; index++) {
                    const eachcustomerDevice = this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index];
                    if (this.customerDevice.selectedCMorFP === '1' && this.customerDevices[i] && this.customerDevices[i].FarmSiteDetails[k] && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index] && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].pond_id == null && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].isContinuousMonitoring) {
                      const cudtomerdeiceid = eachcustomerDevice.id; // provider iyethe device details lo vachina id and farmsitedetails lo customer devies lo vachina id same vunte push cheyakudadhu
                      const providerDevicearr = _.filter(this.deviceDetails, function(o) {
                        return o.id === cudtomerdeiceid;
                      });
                      if (providerDevicearr.length === 0) {
                        let business = await this.getBusinessDetailsById(this.customerDevices[i].FarmSiteDetails[k].businessID);
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].providerId = business && business.id;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessName = business && business.businessName;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessType = business && business.businessType[0].name;
                        this.deviceDetails.push(this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index]);
                      }
                    } else if (this.customerDevice.selectedCMorFP === '0' && this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].isContinuousMonitoring == false) {
                      const cudtomerdeiceid = eachcustomerDevice.id; // provider iyethe device details lo vachina id and farmsitedetails lo customer devies lo vachina id same vunte push cheyakudadhu
                      const providerDevicearr = _.filter(this.deviceDetails, function(o) {
                        return o.id === cudtomerdeiceid;
                      });
                      if (providerDevicearr.length === 0) {
                        let business = await this.getBusinessDetailsById(this.customerDevices[i].FarmSiteDetails[k].businessID);
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].providerId = business && business.id;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessName = business && business.businessName;
                        this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index].businessType = business && business.businessType[0].name;
                        this.deviceDetails.push(this.customerDevices[i].FarmSiteDetails[k].CustomerDevices[index]);
                      }
                    }
                  }
                }
              }
              // end prepare farmsitedetails
                // prepare cms device directly assign to farm -- device not assigned to business admin or provider
              else if ((this.customerDevices[i] && this.customerDevices[i].FarmSiteDetails.length == 0) && this.customerDevices[i].DeviceDetails.length > 0) {
                for (let j = 0; j < this.customerDevices[i].DeviceDetails.length; j++) {
                  if (this.customerDevice.selectedCMorFP == '1' && this.customerDevices[i] && this.customerDevices[i].DeviceDetails[j] && this.customerDevices[i].DeviceDetails[j].pond_id == null && this.customerDevices[i].DeviceDetails[j].isContinuousMonitoring == true) {
                    this.customerDevices[i].DeviceDetails[j].businessName = this.customerDevices[i].businessName;
                    this.customerDevices[i].DeviceDetails[j].providerId = this.customerDevices[i].id;
                    this.customerDevices[i].DeviceDetails[j].businessType = this.customerDevices[i].businessType[0].name;
                    this.deviceDetails.push(this.customerDevices[i].DeviceDetails[j]);
                  }
                }
              }
            }
          }
          // remove duplicates
          this.deviceDetails = _.uniqBy(this.deviceDetails, 'id');
          this.batchLoader?.reset();
          await this.batchLoader?.loadNextBatch(true);
          // end
        }
      }
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  // end Device with Provider list when admin loggedin

  public removetableData() {
    this.deviceDetails = new Array();
    this.displayDeviceDetails = [];
    this.batchLoader?.reset();
    this.isSearchclick = false;
  }

  /*Get Business Details by id*/
  public getBusinessDetailsById(business: any) {
    let businessId = business.id;
    this.businessEntity = this.businessEntities.find(businessEntity => businessEntity && businessEntity.id === businessId);
    return this.businessEntity;
  }
}
